// Module
var code = "<p>In the early stages of CKD there may not be any symptoms at all because the body is usually able to deal with reduced kidney function.</p> ";
// Exports
export default code;